import {
  ControlOutlined,
  DownOutlined,
  EditOutlined,
  LeftOutlined,
  LoadingOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  RollbackOutlined,
  SettingOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Button, Dropdown, Layout, Menu, message, theme } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import { Route, useHistory, useLocation } from 'react-router-dom';
import './App.css';
import Routes from './Routes';
import SideMenu, { getMenuItem } from './SideMenu';
import { CONFIG, TIPOS_PRODUCTOS, USER_STATES } from './constants';
import EmpresaContext from './context/empresa-context';
import SessionContext from './context/session-context';
import UserContext from './context/user-context';
// import LandingSegu from './modelos/cotizaciones/LandingSegu';
import { errorHandler, puedeMostrarMenu, rutasPorGrupo } from './utils';
import { instanceRef } from './utils/axios';

const { Header, Content, Footer } = Layout;
const { useToken } = theme;

const MainApp = () => {
  const history = useHistory();
  const screens = useBreakpoint();
  const { token } = useToken();
  ReactGA.initialize(CONFIG.GOOGLE_ANALYTICS_TRACKING_CODE);
  ReactGA.pageview(history.location.pathname + history.location.search);
  history.listen((location) => {
    ReactGA.pageview(location.pathname + location.search);
  });

  const styles = {
    header: {
      position: 'fixed',
      zIndex: 100,
      width: '100%',
      textAlign: 'center',
      backgroundColor: '#fff',
      padding: 0
    },
    footer: {
      textAlign: 'center',
      // backgroundColor: CONFIG.COLOR_PRIMARY,
      // color: "#fff",
      backgroundColor: '#F3F4F3'
    },
    toggle: {
      fontSize: 20,
      flex: 1,
      marginLeft: 10,
      marginRight: 10,
      color: token.colorPrimary
    },
    button: {
      marginRight: 20,
      justifyContent: 'flex-end'
    }
  };

  const handleClick = async (e) => {
    if (e.key === '1') {
      cerrarSesion();
    } else if (e.key === '2') {
      history.push(`/perfil`, '_blank');
    } else if (e.key === '3') {
      history.push(`/perfil/firma`);
    }
  };

  const [collapsed, setCollapsed] = useState(
    screens.md === false ? true : undefined
  );
  const { setCollapsed: setSessionCollapsed } = useContext(SessionContext);
  const { user, logout, userState } = useContext(UserContext);
  const { empresa, productos, updateProducto } = useContext(EmpresaContext);
  const [cerrandoSesion, setCerrandoSesion] = useState(false);
  const [tieneGestionUsuarios, setTieneGestionUsuarios] = useState();
  const [tieneGestionSistema, setTieneGestionSistema] = useState();
  const [tieneLandingSegu, setTieneLandingSegu] = useState();

  const [menu, setMenu] = useState();

  const esAdmin = user && user['cognito:groups'][0] === 'ADMIN';

  const location = useLocation();
  let layoutStyle = {
    transition: 'all 0.8s'
  };

  if (collapsed !== undefined && screens.md !== undefined) {
    layoutStyle.marginLeft = collapsed ? 80 : 300;
  }
  if (!puedeMostrarMenu(location.pathname, user, userState)) {
    layoutStyle = {};
  }

  const onChangeCollapsed = (value) => {
    setCollapsed(value);
    setSessionCollapsed(value);
  };

  const puedeIngresar = useCallback(
    (to) => {
      if (
        user &&
        user['cognito:groups'] &&
        rutasPorGrupo[user['cognito:groups'][0]]
      ) {
        return (
          rutasPorGrupo[user['cognito:groups'][0]].filter((item) =>
            to.startsWith(item)
          ).length > 0
        );
      }
      return false;
    },
    [user]
  );

  const getProtectedMenuItem = (props) => {
    return puedeIngresar(props.to) && getMenuItem(props);
  };

  useEffect(() => {
    if (setSessionCollapsed) {
      setSessionCollapsed(screens.md === false ? true : undefined);
    }
  }, [screens.md, setSessionCollapsed]);

  useEffect(() => {
    if (
      tieneGestionSistema !== undefined &&
      tieneGestionUsuarios !== undefined
    ) {
      setMenu({
        onClick: handleClick,
        items: [
          empresa &&
            tieneGestionSistema &&
            getProtectedMenuItem({
              to: empresa.id_aseguradora ? '/admin-config' : '/admin-empresa',
              key: 'admin',
              text: 'Configuración',
              icon: <SettingOutlined />
            }),
          (tieneGestionSistema || tieneGestionUsuarios) &&
            getProtectedMenuItem({
              to: '/organizacion',
              key: 'organizacion',
              text: 'Organización',
              icon: <ControlOutlined />
            }),
          esAdmin &&
            getProtectedMenuItem({
              to: '/core',
              key: 'core',
              text: 'Core',
              icon: <SettingOutlined />
            }),
          {
            type: 'divider'
          },
          {
            key: '3',
            label: 'Mi firma',
            icon: <EditOutlined />
          },
          {
            key: '2',
            label: 'Mi cuenta',
            icon: <UserOutlined />
          },
          {
            key: '1',
            label: 'Cerrar sesión',
            icon: <LogoutOutlined />
          }
        ]
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tieneGestionSistema, tieneGestionUsuarios]);

  useEffect(() => {
    if (user) {
      if (user.usuarioSegu.gestion_usuarios) {
        setTieneGestionUsuarios(true);
      } else {
        setTieneGestionUsuarios(false);
      }
      if (user.usuarioSegu.gestion_sistema) {
        setTieneGestionSistema(true);
      } else {
        setTieneGestionSistema(false);
      }
    }
  }, [user]);

  useEffect(() => {
    if (empresa) {
      if (empresa.tiene_landingsegu) {
        setTieneLandingSegu(true);
      } else {
        setTieneLandingSegu(false);
      }
    }
  }, [empresa]);

  const cerrarSesion = async () => {
    try {
      setCerrandoSesion(true);
      await instanceRef.instance.post('auth/logout');
      message.success('Ha cerrado sesión');
      logout();
      setCerrandoSesion(false);
      history.push('/');
    } catch (error) {
      message.warning('No se ha cerrado sesión');
      setCerrandoSesion(false);
    }
  };

  const isEmailVerified = async () => {
    try {
      if (user && (user.email_verified === undefined || !user.email_verified)) {
        setMenu(
          <Menu onClick={handleClick}>
            <Menu.Item key="1" icon={<LogoutOutlined />}>
              Cerrar sesión
            </Menu.Item>
            <Menu.Item key="2" icon={<UserOutlined />}>
              Mi cuenta
            </Menu.Item>
            <Menu.Item key="3" icon={<UserOutlined />}>
              Verificar cuenta
            </Menu.Item>
          </Menu>
        );
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    isEmailVerified();
    if (screens.md === true) {
      const localCollapsed = localStorage.getItem('collapsed');
      const parsedCollapsed = localCollapsed
        ? JSON.parse(localCollapsed)
        : false;
      setCollapsed(parsedCollapsed);
      setSessionCollapsed(parsedCollapsed);
    } else if (screens.md === false) {
      setCollapsed(true);
      setSessionCollapsed(true);
    } else if (!puedeMostrarMenu(location.pathname, user, userState)) {
      setCollapsed(undefined);
      setSessionCollapsed(undefined);
    }
    if (productos && productos.length > 0) {
      if (location.pathname !== '/') {
        const linkTipoProducto = location.pathname.split('/')[1];
        const tipoProducto = TIPOS_PRODUCTOS.find(
          (item) => item.link === linkTipoProducto
        );
        if (tipoProducto) {
          const productoEncontrado = productos.find(
            ({ codigo }) => codigo === tipoProducto.codigo
          );
          if (productoEncontrado) {
            updateProducto(productoEncontrado.id);
          }
        }
      } else {
        updateProducto(productos[0].id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, productos, updateProducto, screens]);

  useEffect(() => {
    if (empresa && productos) {
      const pathProductos = TIPOS_PRODUCTOS.map((item) => item.link);
      if (
        location.pathname &&
        pathProductos.includes(location.pathname.split('/')[1]) &&
        !empresa.tiene_landing &&
        !empresa.tiene_landingsegu
      ) {
        history.push('/login');
        return;
      }

      if (productos.length > 0 && location.pathname === '/') {
        if (
          userState === USER_STATES.loggingEnd ||
          userState === USER_STATES.notLogged
        ) {
          if (user) {
            if (user['cognito:groups'][0] === 'INSPECTOR') {
              history.push('/inspecciones');
            } else if (user['cognito:groups'][0] === 'EJECUTIVO') {
              history.push('/crearcotizacion');
            } else {
              history.push('/panel');
            }
          } else if (empresa.tiene_landing || empresa.tiene_landingsegu) {
            history.push('/');
          } else {
            history.push('/login');
          }
        }
      } else if (location.pathname === '/') {
        if (
          userState === USER_STATES.loggingEnd ||
          userState === USER_STATES.notLogged
        ) {
          if (user) {
            if (user['cognito:groups'][0] === 'INSPECTOR') {
              history.push('/inspecciones');
            } else if (user['cognito:groups'][0] === 'EJECUTIVO') {
              history.push('/crearcotizacion');
            } else {
              history.push('/panel');
            }
          } else {
            history.push('/login');
          }
        }
      }
    }
  }, [history, location.pathname, productos, user, userState, empresa]);

  const isMobileOpen = collapsed === false && screens.md === false;
  const styleNavbar = {
    position: 'fixed',
    zIndex: 10,
    width: '100%',
    padding: 0,
    backgroundColor: '#F3F4F3',
    display: 'flex',
    alignItems: 'center'
  };

  let username = user ? user['cognito:username'] : '';
  if (username) {
    [username] = username.split(':');
  }

  const terminosCondicionesUrl = `/terminos-condiciones`;

  const mostrarBotonLogin = useCallback(() => {
    const noEstaLogueado =
      !user &&
      (userState === USER_STATES.loggingEnd ||
        userState === USER_STATES.notLogged);
    return (
      noEstaLogueado || puedeMostrarMenu(location.pathname, user, userState)
    );
  }, [location.pathname, user, userState]);

  const mostrarBotonSalir = useCallback(() => {
    const loginVerificado =
      userState === USER_STATES.loggingEnd ||
      userState === USER_STATES.notLogged;
    const puedeMostrar = puedeMostrarMenu(location.pathname, user, userState);
    const noEstaLogueado = !user && loginVerificado;
    const esInicioNoLogueado = noEstaLogueado && location.pathname === '/';

    return loginVerificado && !puedeMostrar && !esInicioNoLogueado;
  }, [location.pathname, user, userState]);

  const puedeMostrarMenuOVerMas = useCallback(() => {
    return mostrarBotonLogin() || mostrarBotonSalir();
  }, [mostrarBotonLogin, mostrarBotonSalir]);

  const esLanding =
    location.pathname === '/' || location.pathname === '/vehiculo';
  return (
    <div style={{ overflowX: 'hidden' }}>
      {tieneLandingSegu && esLanding ? (
        <Content>
          <Routes />
        </Content>
      ) : (
        <Layout>
          {puedeMostrarMenuOVerMas() && (
            <Header
              onClick={() => {
                if (isMobileOpen) {
                  setCollapsed(true);
                  setSessionCollapsed(true);
                }
              }}
              style={styleNavbar}
            >
              {' '}
              <div
                style={{
                  flex: 1,
                  textAlign: 'left',
                  display: isMobileOpen ? 'none' : 'block'
                }}
              >
                {mostrarBotonSalir() && (
                  <Button
                    style={{
                      ...styles.button
                    }}
                    type="link"
                    size="middle"
                    icon={<LeftOutlined />}
                    onClick={() => {
                      // window.open('/');
                      history.push('/');
                    }}
                  >
                    Atrás
                  </Button>
                )}
                {empresa?.link_externo && (
                  <Button
                    style={{
                      ...styles.button
                    }}
                    type="link"
                    size="middle"
                    icon={<RollbackOutlined />}
                    onClick={() => {
                      window.location.href = empresa?.link_externo;
                    }}
                  >
                    Volver al portal
                  </Button>
                )}{' '}
              </div>
              {mostrarBotonLogin() && (
                <>
                  <div
                    style={{
                      width: collapsed ? screens.md === true && 80 : 300
                    }}
                  />
                  {collapsed &&
                    screens.md === false &&
                    puedeMostrarMenu(location.pathname, user, userState) && (
                      <div style={styles.toggle}>
                        <div>
                          {React.createElement(
                            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                            {
                              className: 'trigger',
                              style: {
                                ...styles.toggle
                              },
                              onClick: () => {
                                setCollapsed(!collapsed);
                                setSessionCollapsed(!collapsed);
                              }
                            }
                          )}
                        </div>
                      </div>
                    )}
                  {CONFIG.WITH_LOGIN === 'YES' && (
                    <div
                      style={{
                        flex: 1,
                        textAlign: 'right',
                        display: isMobileOpen ? 'none' : 'block'
                      }}
                    >
                      {user && menu ? (
                        <Dropdown
                          trigger="click"
                          style={styles.button}
                          menu={menu}
                        >
                          <Button
                            style={{ ...styles.button }}
                            ghost
                            type="primary"
                            size="middle"
                            loading={cerrandoSesion}
                          >
                            {username} <DownOutlined />
                          </Button>
                        </Dropdown>
                      ) : (
                        <Button
                          style={{
                            ...styles.button
                          }}
                          ghost
                          type="primary"
                          size="middle"
                          onClick={() => {
                            history.push('/login');
                          }}
                        >
                          {userState !== USER_STATES.loggingStart &&
                            'Iniciar sesión'}
                          <>
                            {userState === USER_STATES.loggingStart && (
                              <LoadingOutlined />
                            )}
                          </>
                        </Button>
                      )}
                    </div>
                  )}
                </>
              )}
            </Header>
          )}

          <Layout
            style={{
              ...(screens.md === true ? layoutStyle : null),
              minHeight: '100vh'
            }}
          >
            <Route
              path="/:item?"
              render={(props) => {
                if (collapsed !== undefined && screens.md !== undefined) {
                  return (
                    <SideMenu
                      {...{ collapsed, onChangeCollapsed }}
                      {...props}
                    />
                  );
                }
                return null;
              }}
            />
            <Content
              style={{
                marginTop: puedeMostrarMenuOVerMas() ? 64 : 0,
                opacity: isMobileOpen ? 0.45 : 1
              }}
              onClick={() => {
                if (screens.md === false) {
                  setCollapsed(true);
                  setSessionCollapsed(true);
                }
              }}
              className="App"
            >
              <Routes />
            </Content>
            <Footer
              style={{
                ...styles.footer,
                opacity: isMobileOpen ? 0.45 : 1
              }}
            >
              This site is protected by reCAPTCHA and the Google{' '}
              <a
                href="https://policies.google.com/privacy"
                style={{ color: 'inherit', textDecoration: 'underline' }}
              >
                Privacy Policy
              </a>{' '}
              and{' '}
              <a
                href="https://policies.google.com/terms"
                style={{ color: 'inherit', textDecoration: 'underline' }}
              >
                Terms of Service
              </a>{' '}
              apply.
              <br />
              Los datos ingresados serán utilizados para la presente cotización
              y serán tratados/custodiados de acuerdo a la Ley vigente, por{' '}
              {CONFIG.TITULO}. Los datos no serán compartidos con terceros no
              involucrados en la operación.
              <br />
              Propiedad de Segu360 al servicio de {CONFIG.TITULO} ©2022
              <br />
              <Button type="link" href={terminosCondicionesUrl} target="blank">
                Términos y Condiciones
              </Button>
              <br />
              <br />
              Asunción - Paraguay
            </Footer>
          </Layout>
        </Layout>
      )}
    </div>
  );
};

export default MainApp;
